export const isBookBibleByRealType = (realType = "") => realType.indexOf("bible") === 0;
// Special requirement from D - show paragraphs level in Tree, BC, TOC for any bible.

export const isShowParaLevelByBookRealType = (realType) => {
  return realType ? isBookBibleByRealType(realType) : false;
};
